<template>
  <div>
    <template v-if="pms">
      <space-details />
      <space-photo  v-if="photoAlbumDetails.show"/>
      <space-tab />
    </template>
      <no-pms v-else></no-pms>
  </div>
</template>

<script>
import mixin from "./components/Mixins";
import components from "./components";
import NoPms from "@/components/NoPms.vue";

export default {
  mixins: [components, mixin],

  components: { NoPms },

  computed: {
    photoAlbumDetails: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumDetails;
      },
      set: function (v) {
        this.PHOTOALBUMDETAILS(v);
      },
    },
  },

  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms = pms["51000"].check;
  },

};
</script>


// WEBPACK FOOTER //
// src/pages/PartII/SpaceDetails/index.vue